import React from 'react';
import { render } from 'react-dom';

import MakePaymentFindBooking from '../react/MakePaymentFindBooking';

export default class MakePaymentFindBookingRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model } = this.context.dataset;
    if (!apiUrl || !model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<MakePaymentFindBooking {...jsonModel} apiURL={apiUrl} />, this.context);
  }
}
